import axios from 'axios';
import _ from 'lodash';
import route from 'ziggyRoute';

export default {
    async get(params = {}, config = {}) {
        let url = params.id ? route('shipping-methods.show', { id: params.id }) : route('shipping-methods');
        delete params.id;
        return await axios.get(url, { params, ...config });
    },
    async delete(id) {
        let url = route('shipping-methods.destroy', { id: id });
        return await axios.delete(url);
    },
    async update(id, payload) {
        let url = route('shipping-methods.edit', { id: id });
        let result = await axios.put(url, payload);
        return result.data.data;
    },
    async create(payload) {
        let url = route('shipping-methods.create');
        let result = await axios.post(url, payload);
        return result.data.data;
    },
    async saveReorder(shippingMethods = []) {
        let data = {
            shippingMethods: shippingMethods.map((method) =>
                _.pick(method, ['id', 'dropdownOrder', 'billDropdownOrder', 'invoiceDropdownOrder'])
            ),
        };
        let url = route('shipping-methods.dropdowns.update');
        let result = await axios.put(url, data);
        return result;
    },
};
